import DatePicker from './datepicker';
import SurveyBanner from './survey_banner';
import GeoLocation from './geolocation';
import VenueNav from './venue_nav';

(() => {
  SurveyBanner();
})();

(() => {
  // Tabbed Content
  const tabbedContentElements = [...document.querySelectorAll('.tabbed-content')];

  if (tabbedContentElements.length > 0) {
    import(/* webpackChunkName: "vanilla-tabbed-content" */ '@morsedigital/vanilla-tabbed-content').then(
      ({ default: TabbedContentClass }) => {
        tabbedContentElements.map(
          tabbedContent =>
            new TabbedContentClass({
              element: tabbedContent,
              bodyContainerClass: 'tabbed-content-body',
              navContainerClass: 'tabbed-content-nav',
            })
        );
      }
    );
  }
})();

// Async built into modules
(() => {
  DatePicker('.new-datepicker, .form__input--calender');
})();

(function() {
  VenueNav('venue-navigation');
})();

(() => {
  GeoLocation();
})();
